export function assertUndefinedable<T>(value: T): T | undefined {
  return value;
}

export function assertDefined<T>(value: T | undefined): T {
  if (value === undefined) {
    throw new Error("Assertion failed. expected value to be defined, got undefind instead");
  }

  return value;
}

export function assertNotNull<T>(value: T | null): T {
  if (value === null) {
    throw new Error("Assertion failed. expected value to be defined, got null instead");
  }

  return value;
}
